import styled from "styled-components";



export const TextWrapper = styled.div`
display: flex;
justify-content:center;
align-items:center;
text-align:center;
margin-top: 25px;
@media(max-width:768px){
display: none;
/* visibility:hidden; */
}

`;
export const Text = styled.text`
font-family:sans-serif;
font-style: normal;
font-weight: 400;
font-size: 18px;
line-height: 22px;
color:"white";
padding: 0 8px;
cursor: pointer;
color: ${(p) => p.selected ? "#88FEFE" : "white"};

@media(max-width:1150px){
/* font-size:16px; */
/* padding: 0 10px; */
}   

@media(max-width:1024px){
/* font-size:18px; */
/* padding: 0 8px; */
}

${(p) =>
    p.selected &&
    `
   color: #88FEFE;
`};
`;